import templateUrl from 'emun.auth/register-consumer.htm'
import controller from 'emun.auth/register-consumer.controller'

export default {
    templateUrl,
	bindings: {
		consumer: '<',
		consumerId: '@'
        //cancelUrl: '@',
        //colSplit: '@',
        //termsAndConditionsUrl: '@',
    },
    controller,
};